(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/javascripts/pay/draw-closed-dialog.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/javascripts/pay/draw-closed-dialog.js');

'use strict';

const {
  getProductDayName,
  isKeno
} = svs.numbergames.productMapping;
function drawClosedDialog(_ref) {
  let {
    next,
    cancel,
    closedProductItsId,
    draws
  } = _ref;
  const productDayName = getProductDayName(closedProductItsId);
  const draw = draws.find(d => d.productItsId === closedProductItsId);
  const day = svs.utils.date.FormatTime('EEEE', draw.regCloseTime);
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'exclamation-sign',
    title: " Spelstopp p\xE5 ".concat(productDayName, "!"),
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: isKeno(closedProductItsId) ? "Tiden f\xF6r spelstopp hann passera f\xF6r dagens dragning p\xE5 ".concat(productDayName, ". Du spelar ist\xE4llet p\xE5 dragningen p\xE5 ").concat(day) : "Tiden f\xF6r spelstopp hann passera f\xF6r dagens dragning p\xE5 ".concat(productDayName, ". Du spelar ist\xE4llet p\xE5 dragningen n\xE4sta vecka.")
    }],
    actions: [{
      title: 'Avbryt',
      callback: (e, forms, dialog) => {
        dialog.close();
        cancel();
      }
    }, {
      title: 'Betala',
      callback: (e, forms, dialog) => {
        dialog.close();
        next();
      }
    }]
  }));
}
svs.gamePackage.pay.drawClosedDialog = drawClosedDialog;

 })(window);